// extracted by mini-css-extract-plugin
export default {"Container":"MarkdownViewer_Container__wGxhG","Contents":"MarkdownViewer_Contents__lNkSF","Back":"MarkdownViewer_Back__d7BLB"};